/**
 * Application-wide constants
 */
import type { InterestLevel } from "@habity/types";

/**
 * Default timezone for the application.
 * Used for displaying dates/times consistently across all devices.
 * All viewing times, booking times, etc. are displayed in this timezone.
 */
export const APP_TIMEZONE = "Europe/Stockholm";

/**
 * Default placeholder image for homes without images.
 * Used in search listings, matching emails, etc.
 */
export const DEFAULT_HOME_IMAGE =
  "https://erikolsson.se/eo/images/eo-home-missing-img.jpg";

/**
 * Minimum match score (0–100) for speculator matching.
 * Used by manual search and Trigger.dev automatic matching.
 */
export const SPECULATOR_MATCH_SCORE_MIN = 85;

/**
 * Feature flags
 */

/**
 * Enable/disable broker notifications when homes are published.
 * When true, brokers receive email and in-app notifications when their homes are published.
 */
export const ENABLE_BROKER_NOTIFICATIONS = false;

/**
 * Email address for receiving Cal.com onboarding reports.
 * Weekly CSV report of brokers who have Cal.com accounts but haven't completed onboarding.
 */
export const CAL_ONBOARDING_REPORT_EMAIL = "gabriella.loves@erikolsson.se";

/**
 * Email address for receiving broker focus area review notifications.
 * When a broker submits new focus areas, a plaintext email is sent here for approval.
 */
export const BROKER_AREAS_REVIEW_EMAIL = "christian.lundstrom@erikolsson.se";

/**
 * Interest levels that should trigger user notifications when a speculator relationship
 * is created in VITEC via sendInterestAndContactOnEstate.
 *
 */
export const VITEC_SPECULATOR_NOTIFICATION_INTEREST_LEVELS: InterestLevel[] = [
  "showed_interest",
  "showed_strong_interest",
  "booked_viewing",
  "followed_bidding",
  "placed_bid",
];
